import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  api,
  getTenant,
  GLOBAL_COLORS, handleImageError,
  useGetGravatarOrUploadedProfileImg,
} from '../../../hooks';
import { Account } from '../../../components/account';
import { AppDataContext } from '../../../utils/context';
import { IUserMetaData } from '../../../model';
import './PublicProfileContentView.css';
import { FaFacebookF, FaShareAlt } from 'react-icons/fa';
import { LuPencil } from 'react-icons/lu';
import { FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';

import { inIframe } from '../../../utils';
import ProfileContainer from '../ProfileContainer/ProfileContainer';
import CareerMenu from '../../../components/Career/CareerMenu/CareerMenu';
import accountImg from '../../../assets/images/ibl-user-account.png'
import { IBLSpinLoader } from '../../../components';

export const PublicProfileContentView = ({ username }) => {
  const { appData, setAppData } = useContext(AppDataContext);


  const [facebookUrl, setFacebookUrl] = useState('');
  const [linkedinUrl, setLinkedinUrl] = useState('');
  const [twitterUrl, setTwitterUrl] = useState('');
  const [socialEnabled, setSocialEnabled] = useState(true);
  const [userMetaData, setUserMetaData] = useState<IUserMetaData>(
    inIframe()
      ? null
      : {
          ...appData.userMetaData,
        }
  );
  const [userMetaDataLoaded, setUserMetaDataLoaded] = useState(false);

  const { profilePic } = useGetGravatarOrUploadedProfileImg(userMetaData);



  const [isFocused, setIsFocused] = useState(false);

  const handleProfileClick = () => {
    setIsFocused(!isFocused);
  };

  const { t } = useTranslation('library');



  useEffect(() => {
    if (!userMetaData?.name) {
      api.ibldmusers.getUsersManageMetadata(
        { username, platform_key: getTenant() },
        function (data) {
          setUserMetaData(data);
          setTimeout(()=>{
            setUserMetaDataLoaded(true);
          }, 500)
        }
      );
    }
  }, []);

  useEffect(() => {
    setUserMetaData({ ...appData.userMetaData });
  }, [appData.userMetaData]);

  const [showCareerMenu, setShowCareerMenu] = useState(false);


  const populateSocialMediaLinks = () => {
    const socialLinks = userMetaData?.social_links;
    if (Array.isArray(socialLinks) && socialLinks?.length > 0) {
      socialLinks.forEach(function (socialLink) {
        if (
          !socialLink?.social_link ||
          socialLink?.social_link === '' ||
          socialLink?.social_link === '#'
        ) {
          return;
        }
        const platform = socialLink?.platform;

        if (platform === 'linkedin') {
          setLinkedinUrl('https://linkedin.com/in/' + socialLink?.social_link);
        }
        if (platform === 'twitter') {
          setTwitterUrl('https://twitter.com/' + socialLink?.social_link);
        }

        if (platform === 'facebook') {
          setFacebookUrl('https://www.facebook.com/' + socialLink?.social_link);
        }
      });
    } else {
      setSocialEnabled(false);
    }
  };

  useEffect(() => {
    appData.userMetaDataLoaded && populateSocialMediaLinks();
  }, [appData.userMetaDataLoaded]);

  return (

    <>
      {
        showCareerMenu && (
          <CareerMenu setShowCareerMenu={setShowCareerMenu} />
        )
      }
      <span>
        {
          !userMetaData?.name && !userMetaDataLoaded ? (
            <IBLSpinLoader color={"var(--accent)"} size={30} containerHeight={"200px"} />
          ) : (
            <>
              <div
                data-name={'pp'}
                className="ov_panel active"
                style={{ marginTop: '20px' }}
              >
                <div className="div-block-518">
                  <div className="div-block-445">
                    <img
                      className="image-150"
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash.jpg"
                      alt=""
                      sizes="(max-width: 479px) 100vw, (max-width: 767px) 75vw, (max-width: 991px) 77vw, (max-width: 1279px) 100vw, 1054px"
                      prop-attr-names="src"
                      prop-attr-value-src={'banner'}
                      loading="lazy"
                      srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-500.jpeg 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-800.jpeg 800w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-1080.jpeg 1080w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-1600.jpeg 1600w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-2000.jpeg 2000w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash.jpg 2400w"
                    />
                  </div>

                  <div className="div-block-401">
                    {!inIframe() && (
                      <div
                        data-w-id="f31e1962-462b-8b0d-0045-72a4bb836cf9"
                        onClick={() => setShowCareerMenu(true)}
                        className="div-block-471 edit_profile_trigger"
                      >
                        <LuPencil
                          color={GLOBAL_COLORS.icon_color}
                          className={'image-140 public-profile-icon-img'}
                        />
                      </div>
                    )}

                    <div className="div-block-427">
                      <div>
                        <div className="div-block-516">
                          <div className="div-block-384">
                            <img
                              src={profilePic}
                              loading="lazy"
                              prop-attr-names="src"
                              prop-attr-value-src="photo"
                              alt=""
                              className="image-174"
                              onError={e=>handleImageError(e, accountImg)}
                            />
                          </div>
                        </div>
                        <div>
                          <strong
                            prop-data-value-fullname={'fullname'}
                            prop-data-names="fullname"
                            className="bold-text-5"
                          >
                            {userMetaData?.name || ''}
                          </strong>
                        </div>
                        <div style={{ marginBottom: '12px' }}>
                          {userMetaData?.bio || ''}
                        </div>
                        <div className="followers_text pp">
                          <div
                            data-name="followers"
                            data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d07"
                            className="text-block-226 show_social followers"
                          >
                            120 Following{' '}
                          </div>
                          <div
                            data-name="following"
                            data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d09"
                            className="text-block-226 show_social following"
                          >
                            105 Followers
                          </div>
                        </div>

                        {socialEnabled && (
                          <div className="div-block-408 pp">
                            <a
                              no-mapping=""
                              style={{ display: 'none' }}
                              data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d19"
                              href="#"
                              className="link-block-26 pp w-inline-block"
                            >
                              {/*<FaShareAlt
                        className={'image-149 public-profile-icon-img'}
                        color={GLOBAL_COLORS.icon_color}
                      />*/}
                            </a>
                            {!['', '#'].includes(facebookUrl) && (
                              <a
                                data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d1c"
                                href={facebookUrl}
                                target="_blank"
                                className="link-block-26 pp w-inline-block"
                              >
                                <FaFacebookF
                                  className={'image-149 public-profile-icon-img'}
                                  color={GLOBAL_COLORS.icon_color}
                                />
                              </a>
                            )}
                            {!['', '#'].includes(linkedinUrl) && (
                              <a
                                data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d1f"
                                href={linkedinUrl}
                                target="_blank"
                                className="link-block-26 pp w-inline-block"
                              >
                                <FaLinkedinIn
                                  className={'image-149 public-profile-icon-img'}
                                  color={GLOBAL_COLORS.icon_color}
                                />
                              </a>
                            )}
                            {!['', '#'].includes(twitterUrl) && (
                              <a
                                data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d22"
                                href={twitterUrl}
                                target="_blank"
                                className="link-block-26 pp w-inline-block"
                              >
                                <FaXTwitter
                                  className={'image-149 public-profile-icon-img'}
                                  color={GLOBAL_COLORS.icon_color}
                                />
                              </a>
                            )}
                          </div>
                        )}
                      </div>

                    </div>
                  </div>


                </div>



                {/* MAIN CONTAINER HERE */}

                <ProfileContainer username={username} t={t} appData={appData} setAppData={setAppData} about={userMetaData?.about} />






              </div>
              {isFocused && <Account onModalClose={() => setIsFocused(false)} />}
            </>
          )
        }
      </span>
    </>

    
  

   
  );
};
